import React, {useState, useEffect} from 'react'

import { Button, Container, InputGroup, Form, FormControl, Nav, Navbar } from 'react-bootstrap';

import Login from '../../container/modals/Login'
import ResetPassword from '../../container/modals/ResetPassword';
import Registration from '../../container/modals/Registration';

import {Link, useHistory} from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux'
import { GET_USER_INFO_SUCCESS, SET_MUSIC } from '../../store/action/ActionType'
import {CountCartedMusic} from '../../store/action/MusicAction'

import UserSnackBar from '../snackbar/UserSnackBar';
import { refreshCartCount } from '../../service/cartService';
import useActiveModal from '../../service/activeModalService';
import { getAccessToken, updateTokenChecker } from '../../utils';
import UserInterests from '../../container/modals/UserInterests';
import useNavExpanded from '../../service/navExpandedService';
import Download from '../../container/modals/Download';


function SearchBar({className}) {
  const history = useHistory();
  const [searchText, setSearchText] = useState('');
  const handelSearch = (e) => {
    searchText && history.push('/search/'+encodeURIComponent(searchText));
  };

  return (
    <div className={`search-bar ${className}`}>
      <form className="d-inline-block" onSubmit={handelSearch}>
        <input value={searchText} onChange={e =>{setSearchText(e.target.value)}} className="form-control" type="search" placeholder="Search songs and artists" aria-label="Search"/>
        <button onClick={handelSearch} type="submit"><img src="/img/search.png" alt="img" className="img-fluid"/></button>
      </form>
      {/* <a href="#">Advanced <img src="/img/start.svg" alt="img" className="img-fluid"/></a> */}
    </div>
  );
}


function NavButtons({className}) {
  const history = useHistory();
  const dispatch = useDispatch();

  const { is_superUser} = useSelector(state => state.auth)

  const { get_user_info_success } = useSelector(state => state.user);
  const userId = get_user_info_success && get_user_info_success.id;

  const { getAddToCartCoutSuccess, freshDownloadsCount } = useSelector(state => state.music)

  const { setActiveModal } = useActiveModal();

  async function goToHome() {
    await new Promise((resolve) => setTimeout(() => {
      const access_token = localStorage.getItem('access_token')
      if (!access_token) {
        history.push('/')
      }
  
    },1000))
  }

  const handleLogout  = () =>{
    updateTokenChecker(dispatch, true);

    dispatch({
      type:GET_USER_INFO_SUCCESS,
      data : null,
    })

    refreshCartCount(dispatch);
    
    goToHome()
  }

  return (
    <ul className={`${className} ms-auto mb-2 mb-lg-0`}>
      {/*notifications, but use for profile*/}
      {userId && is_superUser!=="true" && <li className="nav-item">
          <Link to="/profile" className="nav-link" aria-current="page" href="#">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="-1 4 18 8">
              <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" fill="white"/>
            </svg>
            {/* <span className="dot-cuarcale"></span> */}
          </Link>
      </li>}

      {userId && is_superUser==="true" && <li className="nav-item button1">
        <Link className="nav-link " to="/manage-midistax-front">Admin</Link>
      </li>}

      {/*downloads*/}
      {userId && is_superUser!=="true" && <li className="nav-item">
        <Link to="/download" className="nav-link">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.56244 14.0125C3.71162 14.0125 3.8547 14.0717 3.96019 14.1772C4.06568 14.2827 4.12494 14.4258 4.12494 14.575V17.3875C4.12494 17.6858 4.24347 17.972 4.45444 18.1829C4.66542 18.3939 4.95157 18.5125 5.24994 18.5125H18.7499C19.0483 18.5125 19.3345 18.3939 19.5454 18.1829C19.7564 17.972 19.8749 17.6858 19.8749 17.3875V14.575C19.8749 14.4258 19.9342 14.2827 20.0397 14.1772C20.1452 14.0717 20.2883 14.0125 20.4374 14.0125C20.5866 14.0125 20.7297 14.0717 20.8352 14.1772C20.9407 14.2827 20.9999 14.4258 20.9999 14.575V17.3875C20.9999 17.9842 20.7629 18.5565 20.3409 18.9784C19.919 19.4004 19.3467 19.6375 18.7499 19.6375H5.24994C4.6532 19.6375 4.08091 19.4004 3.65895 18.9784C3.23699 18.5565 2.99994 17.9842 2.99994 17.3875V14.575C2.99994 14.4258 3.0592 14.2827 3.16469 14.1772C3.27018 14.0717 3.41325 14.0125 3.56244 14.0125V14.0125Z" fill="white"/>
              <path d="M11.6017 16.2108C11.6539 16.2631 11.716 16.3047 11.7843 16.3331C11.8527 16.3614 11.9259 16.376 11.9999 16.376C12.0739 16.376 12.1472 16.3614 12.2155 16.3331C12.2838 16.3047 12.3459 16.2631 12.3982 16.2108L15.7732 12.8358C15.8788 12.7301 15.9381 12.5869 15.9381 12.4375C15.9381 12.2881 15.8788 12.1449 15.7732 12.0393C15.6675 11.9336 15.5243 11.8743 15.3749 11.8743C15.2255 11.8743 15.0823 11.9336 14.9767 12.0393L12.5624 14.4546V4.5625C12.5624 4.41332 12.5032 4.27024 12.3977 4.16475C12.2922 4.05926 12.1491 4 11.9999 4C11.8507 4 11.7077 4.05926 11.6022 4.16475C11.4967 4.27024 11.4374 4.41332 11.4374 4.5625V14.4546L9.02317 12.0393C8.91754 11.9336 8.77429 11.8743 8.62492 11.8743C8.47554 11.8743 8.33229 11.9336 8.22667 12.0393C8.12104 12.1449 8.06171 12.2881 8.06171 12.4375C8.06171 12.5869 8.12104 12.7301 8.22667 12.8358L11.6017 16.2108V16.2108Z" fill="white"/>
          </svg>
          {freshDownloadsCount>0 && <span style={{color:'#E649FF', fontSize: 14}}>{freshDownloadsCount}</span>}
        </Link>
      </li>}

      {/*cart*/}
      {(!userId || is_superUser!=="true") && <li className="nav-item">
        <Link to="/cart" className="nav-link">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.00037 3.64272C3.00037 3.47226 3.06808 3.30878 3.18862 3.18825C3.30915 3.06771 3.47263 3 3.64309 3H4.20611C5.14063 3 5.67794 3.60801 5.98902 4.21474C6.20111 4.62994 6.35408 5.1364 6.48134 5.57602H19.7149C19.9136 5.57608 20.1095 5.62216 20.2873 5.71066C20.4651 5.79916 20.62 5.92766 20.7398 6.08607C20.8596 6.24449 20.9411 6.42852 20.9778 6.62372C21.0145 6.81891 21.0056 7.01996 20.9515 7.2111L19.0285 13.9918C18.8755 14.5298 18.5513 15.0032 18.105 15.3402C17.6587 15.6773 17.1146 15.8596 16.5553 15.8595H10.0266C9.46263 15.8597 8.91425 15.6745 8.46595 15.3323C8.01765 14.9902 7.69428 14.5101 7.54568 13.9661L6.72043 10.9389C6.7157 10.9253 6.71141 10.9116 6.70758 10.8977L5.38229 6.40256L5.25374 5.96936C5.1252 5.5246 5.01208 5.13126 4.8424 4.8009C4.63802 4.40241 4.45035 4.28672 4.20483 4.28672H3.6418C3.47134 4.28672 3.30787 4.21901 3.18733 4.09848C3.0668 3.97794 2.99908 3.81446 2.99908 3.644L3.00037 3.64272ZM7.94674 10.5507L8.78613 13.6306C8.86055 13.9025 9.02228 14.1424 9.24642 14.3133C9.47057 14.4843 9.74469 14.5768 10.0266 14.5767H16.5566C16.8361 14.5764 17.1079 14.485 17.3308 14.3164C17.5537 14.1477 17.7156 13.911 17.7919 13.6421L19.7149 6.86146H6.86054L7.94674 10.5494V10.5507ZM12.0023 19.0718C12.0023 19.5832 11.7992 20.0737 11.4376 20.4353C11.076 20.7969 10.5855 21 10.0741 21C9.56276 21 9.07233 20.7969 8.71073 20.4353C8.34913 20.0737 8.14598 19.5832 8.14598 19.0718C8.14598 18.5605 8.34913 18.07 8.71073 17.7084C9.07233 17.3468 9.56276 17.1437 10.0741 17.1437C10.5855 17.1437 11.076 17.3468 11.4376 17.7084C11.7992 18.07 12.0023 18.5605 12.0023 19.0718V19.0718ZM10.7169 19.0718C10.7169 18.9014 10.6491 18.7379 10.5286 18.6174C10.4081 18.4968 10.2446 18.4291 10.0741 18.4291C9.90368 18.4291 9.7402 18.4968 9.61967 18.6174C9.49914 18.7379 9.43142 18.9014 9.43142 19.0718C9.43142 19.2423 9.49914 19.4058 9.61967 19.5263C9.7402 19.6468 9.90368 19.7146 10.0741 19.7146C10.2446 19.7146 10.4081 19.6468 10.5286 19.5263C10.6491 19.4058 10.7169 19.2423 10.7169 19.0718ZM18.4295 19.0718C18.4295 19.5832 18.2263 20.0737 17.8647 20.4353C17.5031 20.7969 17.0127 21 16.5013 21C15.99 21 15.4995 20.7969 15.1379 20.4353C14.7763 20.0737 14.5732 19.5832 14.5732 19.0718C14.5732 18.5605 14.7763 18.07 15.1379 17.7084C15.4995 17.3468 15.99 17.1437 16.5013 17.1437C17.0127 17.1437 17.5031 17.3468 17.8647 17.7084C18.2263 18.07 18.4295 18.5605 18.4295 19.0718V19.0718ZM17.1441 19.0718C17.1441 18.9014 17.0763 18.7379 16.9558 18.6174C16.8353 18.4968 16.6718 18.4291 16.5013 18.4291C16.3309 18.4291 16.1674 18.4968 16.0469 18.6174C15.9263 18.7379 15.8586 18.9014 15.8586 19.0718C15.8586 19.2423 15.9263 19.4058 16.0469 19.5263C16.1674 19.6468 16.3309 19.7146 16.5013 19.7146C16.6718 19.7146 16.8353 19.6468 16.9558 19.5263C17.0763 19.4058 17.1441 19.2423 17.1441 19.0718Z" fill="white"/>
          </svg>
          {getAddToCartCoutSuccess>0 && <span style={{color:'#E649FF', fontSize: 14}}>{getAddToCartCoutSuccess}</span>}
        </Link>
      </li>}
      {!userId && <li className="nav-item button1">
        <a className="nav-link " href="#0" onClick={ee =>ee.preventDefault()||setActiveModal('login')}>
          Login
        </a>
      </li>}
      {!userId && <li className="nav-item button2">
        <a className="nav-link" href="#0" onClick={ee=>ee.preventDefault()||setActiveModal('registration')}>
          Register
        </a>
      </li>}
      {userId && <li className="nav-item button1">
        <a className="nav-link " href="#0" onClick={ee=>ee.preventDefault()||handleLogout()}>
          Logout
        </a>
      </li>}
    </ul>
  );
}


function MidiNavbar() {

    const dispatch = useDispatch()
    const { is_superUser} = useSelector(state => state.auth)
    const { addToCartSuccess } = useSelector(state => state.music)
    const { get_user_info_success } = useSelector(state => state.user);

    const userId = get_user_info_success && get_user_info_success.id;

    const { activeModal, setActiveModal } = useActiveModal();

    const { isNavExpanded, setNavExpanded } = useNavExpanded();

    useEffect(() => {
      const accessToken = getAccessToken();
      if (accessToken) {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        };
        dispatch(CountCartedMusic(config));
        is_superUser!=="true" && dispatch(CountCartedMusic(config))
      } else {
        refreshCartCount(dispatch);
      }
    }, [userId])

    return (
      <>
        <header className="fixed-top">
          <div className="container-fluid">
              <nav className="navbar navbar-expand-lg ">
                  <Link className="navbar-brand" to="/">
                      <img src="/img/logo.svg" alt="img" className="img-fluid"/>
                  </Link>
                  <button className="navbar-toggler" type="button" onClick={() => setNavExpanded(!isNavExpanded)}>
                  <span className="d-block">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="#fff">{'<!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->'}<path d="M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z"/></svg>
                  </span>
                  </button>
                  <div className="collapse navbar-collapse" id="navbarSupportedContent">
                      <SearchBar />
                      <NavButtons className="navbar-nav" />
                  </div>
              </nav>
          </div>
        </header>

        {activeModal==='login' && <Login setActiveModal={setActiveModal}/>}
        {activeModal==='password' && <ResetPassword setActiveModal={setActiveModal}/>}
        {activeModal==='registration' && <Registration setActiveModal={setActiveModal}/>}
        {activeModal==='download' && <Download />}
        {!activeModal && get_user_info_success && !get_user_info_success.has_interests && <UserInterests setActiveModal={setActiveModal}/>}

        {addToCartSuccess &&  <UserSnackBar messageKey={addToCartSuccess} />}
      </>
    )
}

export default MidiNavbar;
export { SearchBar, NavButtons };
